export const IDLE_TIME_BEFORE_NOT_TYPING_REQUEST = 3000;

export const MESSAGE_ICON = {
  activating: 'mdi-cogs',
  agentJoined: 'mdi-account-plus',
  forward: 'mdi-forward',
  leftConversation: 'mdi-exit-run',
  notification: 'mdi-lightbulb-on',
  nowChatting: 'mdi-comment-account',
  onHold: 'mdi-pause-circle',
  resumeHold: 'mdi-play-circle',
  merge: 'mdi-call-merge',
  split: 'mdi-call-split'
};

export const MESSAGE_TYPE = {
  idle: 'IDLE',
  isTyping: 'ISTYPING',
  regular: 'REGULAR',
  system: 'SYSTEM',
  textEntered: 'TEXTENTERED',
  delivered: 'DELIVERED'
};
